export default __webpack_public_path__ + "static/media/illustration-resetttttt.67411868.jpg";